import { FC } from 'react';
import { DiscountsUsage } from 'containers/discounts';
import { DiscountsLayout } from 'pages/atoms';

const DiscountsUsagePage: FC = () => {
  return (
    <DiscountsLayout>
      <DiscountsUsage />
    </DiscountsLayout>
  );
};

export default DiscountsUsagePage;
